/**
 * Client-safe builder for the brand-scoped Figma OAuth connect path.
 *
 * Single source for every surface that starts the connect flow (canvas
 * toolbar, integrations page, chat Connect-Figma widget). `returnTo` may
 * carry a query string (e.g. `/emails?chat=abc`)
 * — the connect route sanitizes it via `sanitizeOAuthReturnPath`, which
 * preserves search + hash. Omit `returnTo` to let the route fall back to
 * `/home`.
 */
export const FIGMA_CONNECT_ROUTE = '/api/integrations/figma/connect'

export function buildFigmaConnectPath(returnTo?: string): string {
  const trimmed = returnTo?.trim()
  return trimmed
    ? `${FIGMA_CONNECT_ROUTE}?returnTo=${encodeURIComponent(trimmed)}`
    : FIGMA_CONNECT_ROUTE
}
